module.exports = __webpack_public_path__ + "img/es.d553cd69.svg";